import { Box, Flex } from "@chakra-ui/react";
import { CommonFooter } from "@root/components/auth/commonFooter";
import { Outlet } from "react-router-dom";

const AuthLayout: React.FC = () => {
  return (
    <Flex
      minH="100vh"
      flexDirection="column"
      bg="linear-gradient(0deg, rgba(167, 187, 200, 0.12) 0%, rgba(167, 187, 200, 0.12) 100%), #FFF"
      overflowY="auto"
    >
      <Box flex={1} px={4} py={10}>
        <Flex
          direction="column"
          maxW="1000px"
          mx="auto"
          align="center"
          justify="flex-start"
          minH="auto"
        >
          <Outlet />
        </Flex>
      </Box>
      <CommonFooter />
    </Flex>
  );
};

export default AuthLayout;
